(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 8753:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-authorized-user",
      function () {
        return __webpack_require__(4435);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cb": function() { return /* binding */ FaqP; },
/* harmony export */   "nN": function() { return /* binding */ FaqSidebar; },
/* harmony export */   "xx": function() { return /* binding */ FaqH; },
/* harmony export */   "z$": function() { return /* binding */ FaqTemplate; }
/* harmony export */ });
/* unused harmony export FaqHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_DATA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8362);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
// ** Next Imports




//Faq template
const FaqTemplate = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqHeader, {
                title: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "pad-top-60 pad-bot-60",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-md-9 col-lg-9 col-sm-9 col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "faq-textual",
                                    children: props.children
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSidebar, {})
                        ]
                    })
                })
            })
        ]
    });
//FAQ Header
const FaqHeader = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "bg-silver1 pad-top-40 pad-bot-40",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sec-head",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "no-margin",
                    children: props.title
                })
            })
        })
    });
//FAQ Sidebar
const FaqSidebar = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "col-md-3 col-lg-3 col-sm-3 col-12",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "sidebar",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "block-element m-b-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "list-3",
                    children: Object.keys(_helpers_DATA__WEBPACK_IMPORTED_MODULE_2__/* .FAQ_SIDEBAR_LINKS */ .Dm).map((lName, lKey)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: _helpers_DATA__WEBPACK_IMPORTED_MODULE_2__/* .FAQ_SIDEBAR_LINKS */ .Dm[lName],
                                children: lName
                            })
                        }, "faqsl-".concat(lKey)))
                })
            })
        })
    });
};
//Style Elements for FAQ
const FaqH = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
        className: "col-black",
        children: props.children
    });
const FaqP = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "col-grey1",
        children: props.children
    });


/***/ }),

/***/ 4435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ add_authorized_user; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layouts/default/index.tsx + 7 modules
var layouts_default = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/components/support/faqPages/index.tsx
var faqPages = __webpack_require__(8897);
;// CONCATENATED MODULE: ./public/images/aau.jpg
/* harmony default export */ var aau = ({"src":"/_next/static/media/aau.12bc3926.jpg","height":683,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAACAQMFAQAAAAAAAAAAAAABAgADBBEFBhIhMWH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oADAMBAAIRAxEAPwCPQt9XdV81bVGqNblmfmQX49AH52fMexESkCv/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/pages/add-authorized-user/index.tsx
// ** Next imports


// ** File imports


// ** Img Imports

const AddAuthedUser = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts_default/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_default/* SEOHead */.R, {
                title: "Add Authed User"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(faqPages/* FaqTemplate */.z$, {
                title: "Add Authorized User",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: "Use the form below to add a new Authorized User to your account."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: "Authorized Users can access the following account information:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Billing History"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Payment Information"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Change Plan / Speed"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Report Service Issues"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: "Authorized Users do NOT have access to the following account information:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Service Move Orders"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Adding New Authorized Users"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: "Cancelling Service"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: aau,
                        alt: "Add Authorized User",
                        className: "img-fluid",
                        placeholder: "blur"
                    })
                ]
            })
        ]
    });
/* harmony default export */ var add_authorized_user = (AddAuthedUser);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,910,493,774,888,179], function() { return __webpack_exec__(8753); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);